import React from "react";
import { Box, Grid, Typography } from "@mui/material";
import { ResponsiveContainer, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip as RTooltip } from "recharts";
import PageHeader from "../../components/PageHeader";
import SectionCard from "../../components/SectionCard";
import { tokens } from "../../theme";
import { cohort, rtpBySegment, dormancy } from "../../data/mockData";

const mono = '"IBM Plex Mono", monospace';
const cols = ["D0", "D1", "D3", "D7", "D14"];
const shade = (v) => `rgba(35,214,160,${0.12 + (v / 100) * 0.8})`;

export default function Retention() {
  return (
    <Box>
      <PageHeader title="Retention" crumb="Monitor / Retention" subtitle="Cohorts · realized RTP by segment" />

      <SectionCard title="Cohort retention" subtitle="By signup day · % returning" sx={{ mb: 1.75 }}>
        <Box sx={{ display: "grid", gap: "3px" }}>
          <Box sx={{ display: "grid", gridTemplateColumns: "90px repeat(5,1fr)", gap: "3px" }}>
            <span />
            {cols.map((c) => (
              <Typography key={c} sx={{ textAlign: "center", fontFamily: mono, fontSize: 11, color: tokens.textDim }}>{c}</Typography>
            ))}
          </Box>
          {cohort.map((row) => (
            <Box key={row.day} sx={{ display: "grid", gridTemplateColumns: "90px repeat(5,1fr)", gap: "3px", alignItems: "center" }}>
              <Typography sx={{ fontFamily: mono, fontSize: 11, color: tokens.textDim }}>{row.day}</Typography>
              {row.d.map((v, i) => (
                <Box key={i} sx={{ height: 30, borderRadius: "5px", display: "grid", placeItems: "center", fontFamily: mono, fontSize: 11, fontWeight: 600, color: tokens.onAccent, background: shade(v) }}>
                  {v}
                </Box>
              ))}
            </Box>
          ))}
        </Box>
      </SectionCard>

      <Grid container spacing={1.75}>
        <Grid item xs={12} lg={6}>
          <SectionCard title="Realized RTP by segment" subtitle="Higher = more SC paid back">
            <Box sx={{ height: 240 }}>
              <ResponsiveContainer width="100%" height="100%">
                <BarChart data={rtpBySegment} margin={{ left: -18, right: 8, top: 8 }}>
                  <CartesianGrid strokeDasharray="3 3" stroke={tokens.border} vertical={false} />
                  <XAxis dataKey="seg" stroke={tokens.textDim} fontSize={11} tickLine={false} axisLine={false} />
                  <YAxis domain={[80, 100]} stroke={tokens.textDim} fontSize={11} tickLine={false} axisLine={false} />
                  <RTooltip cursor={{ fill: "rgba(23,26,43,0.04)" }} contentStyle={{ background: tokens.surface2, border: `1px solid ${tokens.border}`, borderRadius: 8 }} />
                  <Bar dataKey="rtp" radius={[6, 6, 0, 0]} fill={tokens.accent} />
                </BarChart>
              </ResponsiveContainer>
            </Box>
          </SectionCard>
        </Grid>

        <Grid item xs={12} lg={6}>
          <SectionCard title="Dormancy distribution" subtitle="Days since last deposit">
            <Box sx={{ height: 240 }}>
              <ResponsiveContainer width="100%" height="100%">
                <BarChart data={dormancy} margin={{ left: -10, right: 8, top: 8 }}>
                  <CartesianGrid strokeDasharray="3 3" stroke={tokens.border} vertical={false} />
                  <XAxis dataKey="bucket" stroke={tokens.textDim} fontSize={11} tickLine={false} axisLine={false} />
                  <YAxis stroke={tokens.textDim} fontSize={11} tickLine={false} axisLine={false} />
                  <RTooltip cursor={{ fill: "rgba(23,26,43,0.04)" }} contentStyle={{ background: tokens.surface2, border: `1px solid ${tokens.border}`, borderRadius: 8 }} />
                  <Bar dataKey="count" radius={[6, 6, 0, 0]} fill={tokens.blue} />
                </BarChart>
              </ResponsiveContainer>
            </Box>
          </SectionCard>
        </Grid>
      </Grid>
    </Box>
  );
}
